module.exports = __webpack_public_path__ + "static/media/iium.39bcc39b.jpeg";